'use strict';

import React from 'react';
import PropTypes from 'prop-types';
import { Row } from 'react-bootstrap';
import { withRouter } from 'react-router-dom';
const get = require('lodash/get');
const find = require('lodash/find');
const sortBy = require('lodash/sortBy');
const findIndex = require('lodash/findIndex');
const filter = require('lodash/filter');
const some = require('lodash/some');
const values = require('lodash/values');
const flatMap = require('lodash/flatMap');
const uuid = require('uuid');
const Moment = require('moment');

const Globals = require('../../../../app/globals');
const Strings = require('../../../../app/shared/Strings');
const ChannelStore = require('../../stores/channel_store_reflux');
const ProjectStore = require('../../stores/ProjectStore');
const SignInStore = require('../../stores/SignInStore');
const SubscriptionPlanStore = require('../../stores/SubscriptionPlanStore');
const SubscriptionPlanActions = require('../../actions/SubscriptionPlanActions');
const FeatureUtil = require('../../../../app/shared/FeatureUtil');
import Navigator from '../../Navigator';
import SideMenu from '../nav/SideMenu';
import SlideMenu from '../nav/SlideMenu';
import LoadingMainContent from '../loading/LoadingMainContent';
import ChannelListItem from '../nav/ChannelListItem';
import ErrorBox from '../common/ErrorBox';
import ProjectsView from '../dashboard/ProjectsView';
import SiteMessageBar from '../dashboard/SiteMessageBar';
import HomeNullSelect from '../dashboard/HomeNullSelect';

const propTypes = {
    history: PropTypes.object.isRequired,
    viewToken: PropTypes.oneOf(values(Globals.view_tokens.author_dash)),
    viewTokenChannel: PropTypes.oneOf(values(Globals.view_tokens.author_dash.channel_views)),
    subViewTokenChannel: PropTypes.oneOf(flatMap(Globals.view_tokens.author_dash.channel_subviews, view => values(view))),
    channelId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};

const defaultProps = {};

class AuthorDashboard extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            channelStoreState: ChannelStore.getState(),
            projectStoreState: ProjectStore.getState(),
            signInStoreState: SignInStore.getState(),
            menuVisible: false,
            subscriptionChecked: false,
            subscriptionEndedDate: null,
        };

        this.checkSubscription = this.checkSubscription.bind(this);
        this.gotoHomeChannel = this.gotoHomeChannel.bind(this);
        this.switchChannelHandler = this.switchChannelHandler.bind(this);
        this.toggleMenu = this.toggleMenu.bind(this);
        this.hideMenu = this.hideMenu.bind(this);
        this.handleCloseSubscriptionExpired = this.handleCloseSubscriptionExpired.bind(this);
        this.handleCancelExpiredSubscription = this.handleCancelExpiredSubscription.bind(this);
        this.isDataLoaded = this.isDataLoaded.bind(this);
        this.verifyCurrentViewAccess = this.verifyCurrentViewAccess.bind(this);
        this.redirectBasedOnState = this.redirectBasedOnState.bind(this);
        this.unsubscribes = [
            ChannelStore.listen(this.onChannelStoreChange.bind(this)),
            ProjectStore.listen(this.onProjectStoreChange.bind(this)),
            SignInStore.listen(this.onSignInStoreChange.bind(this)),
            SubscriptionPlanStore.listen(this.onSubscriptionStoreChange.bind(this))
        ];
    }

    componentDidMount() {
        if (
            !this.props.channelId
            && values(Globals.view_tokens.author_dash).indexOf(this.props.viewToken) === -1
        ) {
            console.warn('Dashboard: Missing channel ID or view token -> DashboardHome');
            this.gotoHomeChannel();
            return;
        }

        if (this.state.signInStoreState.initialized && !this.state.subscriptionChecked) {
            this.checkSubscription(this.state.signInStoreState.userInfo.id);
        }

        this.redirectBasedOnState(this.props.channelId, this.state.channelStoreState);
    }

    componentWillUnmount() {
        this.unsubscribes.forEach(u => u());
    }

    onSubscriptionStoreChange(state) {
        if (this.state.subscriptionChecked) {
            return;
        }

        if (state && state.subscription_plan && state.subscription_plan.subscription) {
            const sd = state.subscription_plan.subscription;
            if (sd.status === Globals.ecommerce.subscription_statuses.active) {
                if (sd.ending_at) {
                    const now = Moment(new Date()).subtract(7,'days'); // add some leeway in case their charge needs time to clear
                    const end_date = Moment(sd.ending_at);
                    if (end_date.isBefore(now) && (!this.state.signInStoreState.userInfo.admin)) {
                        this.setState({
                            subscriptionChecked: true,
                            subscriptionEndedDate: end_date.format('YYYY-MM-DD'),
                            subscription_check_action_id: null,
                            subscription_id: sd.id,
                        });
                        return;
                    }
                }
            }
        }

        this.setState({
            subscriptionChecked: true,
            subscriptionEndedDate: null,
            subscription_check_action_id: null,
        });
    }

    onSignInStoreChange(storeState) {
        if (storeState.initialized && !this.state.subscriptionChecked) {
            this.checkSubscription(storeState.userInfo.id);
        }

        this.setState({ signInStoreState: storeState }, () => {
            this.verifyCurrentViewAccess();
        })
    }
    
    redirectBasedOnState(currentChannelId, channelStoreState) {
        const userInfo = this.state.signInStoreState.userInfo;
        const currentChannel = find(channelStoreState.channelsAndOrgs, { 'id': parseInt(currentChannelId) });
        if (
            channelStoreState.initialized
            && !!currentChannelId
            && !currentChannel //user navigated to channel url which is not found or they do not have access to
        ) {
            const firstChannelId = get(channelStoreState.channelsAndOrgs[0], ['id'], null);
            if (
                currentChannelId == userInfo.id
                && !FeatureUtil.hasPersonalChannel(userInfo.account_permissions)
                && !!firstChannelId
            ) {
                // for users without personal channel attempt to find and transition to the first channel available
                Navigator.goToDashboardAuthorAuthoringChannelView(this.props.history, firstChannelId);
            }
            else {
                // else go to home channel.
                // users without personal channel and no other channel and or permissions will see "select a..." but have no options ¯\_(ツ)_/¯
                Navigator.goToDashboardAuthorAuthoringChannelView(this.props.history, userInfo.id);
            }
        }
        else {
            this.verifyCurrentViewAccess();
        }
    }

    onChannelStoreChange(storeState) {
        this.setState({ channelStoreState: storeState }, () => {
            this.redirectBasedOnState(this.props.channelId, this.state.channelStoreState);
        });
    }

    onProjectStoreChange(state) {
        this.setState({ projectStoreState: state }, () => {
            this.verifyCurrentViewAccess();
        });
    }

    checkSubscription(user_id) {
        const actionId = uuid.v4();
        this.setState({ subscription_check_action_id: actionId }, () => {
            SubscriptionPlanActions.getSubscriptionPlan(actionId);
        });
    }

    gotoHomeChannel() {
        this.switchChannelHandler(this.state.signInStoreState.userInfo.id);
    }

    switchChannelHandler(channelId) {
        Navigator.goToDashboardAuthorAuthoringChannelView(this.props.history, channelId);
    }

    toggleMenu() {
        this.setState({ menuVisible: !this.state.menuVisible });
    }

    hideMenu() {
        this.setState({ menuVisible: false });
    }

    handleCloseSubscriptionExpired() {
        // TODO
        this.props.history.push(`/dashboard/${Globals.view_tokens.dashboard.SETTINGS}`);
    }

    handleCancelExpiredSubscription() {
        if (this.state.subscription_id) {
            const actionId = uuid.v4();
            SubscriptionPlanActions.cancelSubscription(actionId, { subscription_id: this.state.subscription_id });
        }
        else {
            console.log("handleCancelExpiredSubscription didn't have a subscription_id");
        }

        this.setState({ subscriptionEndedDate: null }); // this will close the confirm dialog
    }

    canViewAssignmentsInstructor(channelsAndOrgs) {
        // can create ad hoc assignments in any channel user has access to (including orgs!)
        return some(channelsAndOrgs, (ch) => {
            return FeatureUtil.hasAdHocAssignments(ch.channel_permissions);
        });
    }

    canViewAssignmentsStudent() {
        // default true, no check for this
        return true;
    }

    isDataLoaded() {
        return (
            this.state.signInStoreState.initialized &&
            this.state.channelStoreState.initialized &&
            this.state.projectStoreState.initialized &&
            !(this.state.channelStoreState.error || this.state.projectStoreState.error)
        );
    }

    // if a user has navigated to a view to which they do not have access
    // forward to DashboardHome component path
    verifyCurrentViewAccess() {
        const viewToken = this.props.viewToken;
        if (
            !viewToken
            || !this.isDataLoaded()
        ) {
            return;
        }

        if (
            (viewToken === Globals.view_tokens.author_dash.INSTRUCTOR_ASSIGNMENTS || viewToken === Globals.view_tokens.author_dash.INSTRUCTOR_COURSE_INSTS)
            && !this.canViewAssignmentsInstructor(this.state.channelStoreState.channelsAndOrgs)
        ) {
            this.gotoHomeChannel();
        }
        else if (
            (viewToken === Globals.view_tokens.author_dash.STUDENT_ASSIGNMENTS || viewToken === Globals.view_tokens.author_dash.STUDENT_COURSE_INSTS)
            && !this.canViewAssignmentsStudent()
        ) {
            this.gotoHomeChannel();
        }
//        else if (
//            viewToken === Globals.view_tokens.author_dash.GROUPS
//            && !this.canViewGroups(this.state.signInStoreState.userInfo)
//        ) {
//            this.gotoHomeChannel();
//        }
    }

    render() {
        const viewToken = this.props.viewToken;
        let channelMenuItems = [];
        let orgMenuItems = [];
        let mainContent;

        // if (this.state.subscriptionChecked && this.state.subscriptionEndedDate) {
        //     return (
        //         <div className="view-wrapper">
        //             <MainNav />
        //             <ConfirmModal
        //                 show
        //                 modalTitle="Subscription Expired"
        //                 text={"Your subscription expired as of " + this.state.subscriptionEndedDate}
        //                 buttonText="go to settings"
        //                 closeHandler={this.handleCloseSubscriptionExpired}
        //                 confirmHandler={this.handleCloseSubscriptionExpired}
        //                 cancelButtonText="cancel subscription"
        //                 cancelHandler={this.handleCancelExpiredSubscription}
        //             />
        //         </div>
        //     );
        // }

        if (this.isDataLoaded()) {
            const channels = sortBy(this.state.channelStoreState.channels, 'name');
            const organizations = sortBy(this.state.channelStoreState.organizations, 'name');
            const numChannelsAndOrgs = channels.length + organizations.length;
            const currentChannelId = parseInt(this.props.channelId, 10);
            const homeChannelId = this.state.signInStoreState.userInfo.id;
            const hasPersonalChannel = FeatureUtil.hasPersonalChannel(this.state.signInStoreState.userInfo.account_permissions);
            if (hasPersonalChannel) {
                const homeChannelIndex = findIndex(channels, { id: homeChannelId });
                // put home channel at top of list
                const homeChannel = channels.splice(homeChannelIndex, 1)[0];
                channels.unshift(homeChannel);
            }

            channelMenuItems = channels.map((channel) => {
                return (
                    <ChannelListItem
                        key={channel.id}
                        name={`${channel.name}${channel.id === homeChannelId ? ' (you)' : ''}`}
                        count={filter(this.state.projectStoreState.projects, p => p.channelId === channel.id).length}
                        onClick={this.switchChannelHandler.bind(this, channel.id)}
                        selected={(viewToken === Globals.view_tokens.author_dash.CHANNEL) && parseInt(channel.id, 10) === currentChannelId}
                        isHome={channel.id === homeChannelId}
                    />
                );
            });

            orgMenuItems = organizations.map((channel) => {
                return (
                    <ChannelListItem
                        key={channel.id}
                        name={channel.name}
                        count={filter(this.state.projectStoreState.projects, p => p.channelId === channel.id).length}
                        onClick={this.switchChannelHandler.bind(this, channel.id)}
                        selected={(viewToken === Globals.view_tokens.author_dash.CHANNEL) && parseInt(channel.id, 10) === currentChannelId}
                        isHome={channel.id === homeChannelId}
                    />
                );
            });

            if (!currentChannelId) { // TODO HACK component is in process of transitioning to a channel, fix this in a more appropriate place
                return null;
            }

            if (currentChannelId === homeChannelId && !hasPersonalChannel) {
                mainContent = <HomeNullSelect noAvailableChannels={numChannelsAndOrgs === 0} />;
            }
            else {
                mainContent = (
                    <ProjectsView
                        channelId={currentChannelId}
                        orgId={currentChannelId}
                        viewToken={this.props.viewTokenChannel}
                        subViewToken={this.props.subViewTokenChannel}
                        renderBeforeLodingTags
                    />
                );
            }
        }
        else if (this.state.channelStoreState.error) {
            mainContent = (
                <div>
                    <ErrorBox error={this.state.channelStoreState.error} />
                </div>
            );
        }
        else if (this.state.projectStoreState.error) {
            mainContent = (
                <div>
                    <ErrorBox error={this.state.projectStoreState.error} />
                </div>
            );
        }
        else {
            mainContent = <LoadingMainContent />;
        }

        return (
            <div className="view-wrapper no-min-height">

                <div className="container-fluid main-container no-min-height">
                    <Row className="main-content-nav new no-min-height">
                        <SideMenu
                            channels={channelMenuItems}
                            organizations={orgMenuItems}
                        />
                        <SlideMenu
                            channels={channelMenuItems}
                            organizations={orgMenuItems}
                            side="left"
                            visible={this.state.menuVisible}
                            hideMenu={this.hideMenu}
                        />
                        <div className="main-content no-pad no-min-height">
                            <SiteMessageBar />
                            <div className="main-content__content author_dashboard">
                                <button
                                    className="bare-text-button d-inline-block d-sm-none margin-bottom-md"
                                    onClick={this.toggleMenu}
                                >
                                    <span className="fa fa-bars hamburger margin-right-sm" aria-hidden={true} />
                                    {Strings['en'].dashboard.CHANNELS_HAMBURGER_TITLE}
                                    <span className="fa fa-caret-right margin-left-sm" aria-hidden={true} />
                                </button>
                                {mainContent}
                            </div>
                        </div>
                    </Row>
                </div>
            </div>
        );
    }
}

AuthorDashboard.propTypes = propTypes;
AuthorDashboard.defaultProps = defaultProps;

export default withRouter(AuthorDashboard);